import React, { useEffect, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';
import { useInternetStatus } from '../../utils/internet-check';

/**
 * Компонент для отображения уведомления об отсутствии интернет-соединения
 */
const InternetStatus = () => {
  const isOnline = useInternetStatus();
  const [wasOffline, setWasOffline] = useState(false);
  const [showOfflineAlert, setShowOfflineAlert] = useState(false);
  const [showOnlineAlert, setShowOnlineAlert] = useState(false);

  useEffect(() => {
    if (!isOnline) {
      // Показываем уведомление об отсутствии интернета
      setShowOfflineAlert(true);
      setWasOffline(true);
    } else {
      // Скрываем уведомление об отсутствии интернета
      setShowOfflineAlert(false);
      
      // Если интернет восстановился после отключения, показываем уведомление о восстановлении
      if (wasOffline) {
        setShowOnlineAlert(true);
        setWasOffline(false);
      }
    }
  }, [isOnline, wasOffline]);

  const handleCloseOffline = () => {
    setShowOfflineAlert(false);
  };

  const handleCloseOnline = () => {
    setShowOnlineAlert(false);
  };

  return (
    <>
      {/* Уведомление об отсутствии интернета - всегда видимо пока нет интернета */}
      <Snackbar
        open={showOfflineAlert}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        sx={{
          top: '24px !important',
        }}
      >
        <Alert
          severity="error"
          variant="filled"
          onClose={handleCloseOffline}
          sx={{
            minWidth: '300px',
            '& .MuiAlert-message': {
              fontWeight: 500,
            },
          }}
        >
          Нет интернет-соединения. Проверьте подключение к сети.
        </Alert>
      </Snackbar>

      {/* Уведомление о восстановлении интернета */}
      <Snackbar
        open={showOnlineAlert}
        autoHideDuration={3000}
        onClose={handleCloseOnline}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        sx={{
          top: '24px !important',
        }}
      >
        <Alert
          severity="success"
          variant="filled"
          onClose={handleCloseOnline}
          sx={{
            minWidth: '300px',
            '& .MuiAlert-message': {
              fontWeight: 500,
            },
          }}
        >
          Интернет-соединение восстановлено.
        </Alert>
      </Snackbar>
    </>
  );
};

export default InternetStatus;

